import { Ecommerce, Taxonomy } from '../contracts';
import { mapTracking } from './mapTracking';
import { mapTraitsToTaxonomy } from './mapTraitsToTaxonomy';

// This shares code almost entirely with trackSegmentAndGAEvent, can we
// deprecate this/remove it entirely in favour of trackSegmentAndGAEvent
export const trackPage = async (taxonomy: Taxonomy, ecommerce?: Ecommerce) => {
    const eventData = mapTracking(taxonomy, ecommerce);

    if (!eventData) return;

    if (typeof window.analytics !== 'undefined') {
        window.analytics.ready(() => {
            const traits = window.analytics?.user().traits();
            window.analytics?.track(
                'Viewed Page',
                {
                    ...eventData,
                    taxonomy: {
                        ...eventData.taxonomy,
                        ...mapTraitsToTaxonomy(traits)
                    }
                },
                { traits }
            );
        });
    }
};
